// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hR_c","col":"styles_col__1NG-b"};